var TestComponent = Backbone.View.extend({
  initialize: function() {
    this.$el.css({ background: "black", color: "white" });
  }
});

module.exports = TestComponent;
